export default "__VITE_ASSET__C8xh_TTw__";